<template>
  <div>
    <div class="bl-login-wrap" v-if="vClass != 'change'">
      <div class="bl-bg-head"></div>
      <div class="bl-register-box" v-loading="loading">
        <div class="flex">
            <div></div>
            <div class="theme-color pointer font-size-13 .m-r-4" @click="registrationBackHome">
                <span class="backHomeS">{{ $t('logins.backHome') }}</span>
            </div>
        </div>
        <v-register-step :stepType="registerId"></v-register-step>
        <div :class="['v-questionnaire-wrap', vClass == 'change' ? 'v-personal-question' : '']">
          <v-register-step v-if="!isLogin" :stepType="registerId"></v-register-step>
          <div class="flex-start align-center v-question-title m-l-30">
            <span class="font-size-20">{{ $t('Questionnaire') }}</span>
            <div class="v-progress m-l-12">
              <el-progress :percentage="percentage"></el-progress>
            </div>
          </div>
          <v-radio-question
            :answer.sync="answerList"
            :questionData="currQuestion"
            v-if="questionType == 'Radio'"
          ></v-radio-question>
          <v-checkbox-question
            :answer.sync="answerList"
            :questionData="currQuestion"
            v-if="questionType == 'CheckBox'"
          ></v-checkbox-question>
          <div class="bottom-todo" v-if="pageInit">
            <div class="v-btn-box flex quesBtn">
              <el-button
                :disabled="currPage < 2 || btnDisabled"
                type="primary"
                @click="topQuestion"
              >{{ $t('Top') }}</el-button>
              <el-button
                type="primary"
                :loading="loading"
                :disabled="btnDisabled"
                @click="nextQuestion"
                v-if="questionId"
              >{{ $t('Next') }}</el-button>
              <el-button
                type="primary"
                :loading="loading"
                :disabled="btnDisabled"
                @click="submit"
                v-if="!questionId"
              >{{ $t('submit') }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div :class="['v-questionnaire-wrap', vClass == 'change' ? 'v-personal-question' : '']">
          <el-alert
            v-if="subjectType == 'ACTOR'"
            :title="$t('hm.questionTip')"
            :closable="false"
            type="warning"
            style="padding-left: 8px;font-size: 14px; margin-bottom: 16px;">
          </el-alert>
          <v-register-step v-if="!isLogin" :stepType="registerId"></v-register-step>
          <div class="flex-start align-center v-question-title">
            <span class="font-size-20">{{ $t('Questionnaire') }}</span>
            <div class="v-progress m-l-12">
              <el-progress :percentage="percentage"></el-progress>
            </div>
          </div>
          <v-radio-question
            :answer.sync="answerList"
            :questionData="currQuestion"
            v-if="questionType == 'Radio'"
          ></v-radio-question>
          <v-checkbox-question
            :answer.sync="answerList"
            :questionData="currQuestion"
            v-if="questionType == 'CheckBox'"
          ></v-checkbox-question>
          <div class="bottom-todo" v-if="pageInit">
            <div class="v-btn-box flex quesBtn">
              <el-button
                :disabled="currPage < 2 || btnDisabled"
                type="primary"
                @click="topQuestion"
              >{{ $t('Top') }}</el-button>
              <el-button
                type="primary"
                :loading="loading"
                :disabled="btnDisabled"
                @click="nextQuestion"
                v-if="questionId"
              >{{ $t('Next') }}</el-button>
              <el-button
                type="primary"
                :loading="loading"
                :disabled="btnDisabled"
                @click="submit"
                v-if="!questionId"
              >{{ $t('submit') }}</el-button>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import vRadioQuestion from '@/components/question/vRadioQuestion'
import vCheckboxQuestion from '@/components/question/vCheckboxQuestion'
import { loadQuestion, saveQuestion } from '@/api/index'
import { mapGetters } from 'vuex'
import vRegisterStep from '@/components/login/register_step.vue'

export default {
  name: 'questionnaire',
  components: {
    vRadioQuestion,
    vCheckboxQuestion,
    vRegisterStep
  },
  data() {
    return {
      registerId: 5,
      // checkboxAnswerList:{},//多选答案
      // radioAnswerList:{}, //单选答案
      vClass: this.$route.params.type,
      loading: false,
      currPage: 0,
      count: 1,
      questionId: '',
      questionType: '',
      answerList: {}, //当前题的答案
      currQuestion: {}, //当前问卷
      allQuestion: [], //所有问卷-只做缓存用
      allSelectAnswer: [], //所有选择的答案-只做缓存用
      pageInit: false,
      btnDisabled: false
    }
  },
  computed: {
    percentage() {
      //进度条
      let num = (this.currPage / this.count) * 100
      num = Math.floor(num)

      if (this.currQuestion.nextQuestionId === '') {
        return 100
      }

      return num
    },
    answerIsEmpty() {
      //答案是否为空
      return JSON.stringify(this.answerList) === '{}'
    },
    ...mapGetters(['language', 'languageOld', 'subjectType', 'info', 'config', 'isLogin', 'invitationSource'])
  },
  beforeRouteEnter(to, from, next) {
    /**
     * 进入页面后
     * 判断用户语言是否与本地语言是否一致，且 不是来自手机号完善1和邮箱完善1 且 没有标记language没有修改过
     * 把旧的本地语言同步成新的本地语言
     */
    next(vm => {
      let langChange = sessionStorage.getItem('langChange')
      if (from.name != 'lAccountInfoMobile' && from.name != 'lAccountInfoEmail' && langChange != 1) {
        vm.$store.commit('SET_LANGUAGE_OLD', vm.language)
      }
    })
  },
  watch: {
    answerList: function() {
      if (this.currQuestion.otpCode && this.currQuestion.otpCode === 'CheckBox') {
        let len = Object.keys(this.answerList).length
        if (len >= 80) {
          this.$notify.error({
            message: this.$t('questionTip2'),
            type: 'err'
          })
          this.btnDisabled = true
        } else {
          this.btnDisabled = false
        }
      }
    }
  },
  methods: {
    // 分享广告完成预登记完成埋点
    shareRegister() {
      if (this.$route.path === '/questionnaire') {
        this.completeVisitorRegisterSharingStatistics()
      }
    },
    // 问卷埋点
    burying(n) {
      if (n === undefined) return
      if (this.$route.path === '/questionnaire') {
        let str = ''
        if (n > 9) {
          str = `0106${n}`
        } else {
          str = `01060${n}`
        }
        this.$tracking(str)
      }
    },
    nextQuestion() {
      //下一题
      window.PC.$RangersEventQuestion('questionPage_nextBtn_click')
      let _this = this
      if (!_this.regAnswer()) {
        //js 效验问卷
        return ''
      }

      if (_this.questionType == 'Radio') {
        for (let i in _this.answerList) {
          let obj = _this.answerList[i]
          _this.questionId = obj.nextQuestionId
        }
      } else {
        _this.questionId = _this.currQuestion.nextQuestionId
      }
      if (!_this.questionId) {
        //提交
      } else {
        // 加载下一题

        _this.loadQuestions(_this.saveQuestionData())
      }
    },
    topQuestion() {
      //上一题
      window.PC.$RangersEventQuestion('questionPage_Laststep_click')
      let _this = this
      let status = false
      let num = _this.currPage
      let allQuestion = sessionStorage.getItem('allQuestion')
      let allSelectAnswer = sessionStorage.getItem('allSelectAnswer')
      allQuestion = JSON.parse(allQuestion)
      allSelectAnswer = JSON.parse(allSelectAnswer)
      status = (num <= allQuestion.length)
      num--
      num = num < 0 ? 0 : num
      _this.currPage = num
      if (status) {
        allQuestion.pop()
        allSelectAnswer.pop()
      }
      _this.currQuestion = allQuestion.pop()
      // _this.questionId = sessionStorage.getItem('questionId')
      _this.questionId = this.currQuestion.nextQuestionId
      _this.answerList = allSelectAnswer.pop()
      _this.questionType = _this.currQuestion.questionType.otpCode
      _this.allQuestion = allQuestion
      _this.allSelectAnswer = allSelectAnswer
      sessionStorage.setItem('currentQuestionAnswer', JSON.stringify(_this.currQuestion)) //缓存当前选择项
      sessionStorage.setItem('allQuestion', JSON.stringify(_this.allQuestion)) //缓存答过的题
      sessionStorage.setItem('allSelectAnswer', JSON.stringify(_this.allSelectAnswer)) //缓存答过的题 答案
      sessionStorage.setItem('questionId', _this.questionId) //缓存下一题id
      _this.burying(num)
    },

    loadQuestions(fun) {
      let _this = this
      _this.loading = true
      let num = _this.currPage
      let param = {
        questionId: _this.questionId
      }
      loadQuestion(param)
        .then(res => {
          if (res.data.code == 1000) {
            fun && fun(res)
            num++
            num = num > res.data.data.count ? res.data.data.count : num
            _this.currPage = num
            _this.answerList = {}
            _this.count = res.data.data.count
            _this.currQuestion = { ...res.data.data }
            _this.questionId = res.data.data.nextQuestionId
            _this.questionType = res.data.data.questionType.otpCode
            _this.burying(num)
          }
        })
        .finally(() => {
          _this.loading = false
          this.pageInit = true
        })
    },
    async submit() {
      //提交问卷
      let _this = this
      if (!_this.regAnswer()) {
        //问卷-未通过，不能提交
        return ''
      }
      window.PC.$RangersEventQuestion('questionPage_Submit_click')
      let param = {}
      let answerArr = []
      _this.saveQuestionData() //缓存下当前题
      let allAnswer = sessionStorage.getItem('allSelectAnswer')
      allAnswer = JSON.parse(allAnswer)
      for (let i = 0; i < allAnswer.length; i++) {
        let obj = allAnswer[i]
        for (let k in obj) {
          answerArr.push(obj[k])
        }
      }
      param.answerArray = answerArr
      if (!this.isCompleteExhibitionRegistration() 
      && this.$funcs.getType(this.invitationSource) === 'object' 
      && this.invitationSource.exhibitorId 
      && this.invitationSource.exhibitorEmployeeUserAccountId) {
        param.invitationRecord = this.invitationSource
        this.$store.commit('SET_INVITATION_SOURCE')
      }
      _this.loading = true
      await saveQuestion(param)
        .then(async (res) => {
          if (res.data.code == '1000') {
            if (this.vClass == 'change') {
              // 修改问卷页
              _this.$notify({
                message: _this.$t('submit successfully'),
                type: 'success'
              })
            } else {
              // 预登记问卷页
              // _this.$notify({
              //   message: _this.$t('Successful pre-registration'),
              //   type: 'success',
              //   duration: 6000
              // })

              // 手动更新 info 预登记状态
              let info = this.info
              info.exhibitionUserCompleteState.completeExhibitionRegistration = true
              info.exhibitionUserCompleteState.completeQuestionnaire = true
              info.visitor.cardNumber = res.data.data || ''
              await this.$store.commit('SET_INFO', info)
              await this.shareRegister()
              await this.loginSuccess(_this.subjectType, {}, null, { question: true })
            }
          }
        })
        .finally(() => (_this.loading = false))
    },
    saveQuestionData() {
      // 数据缓存 s
      let _this = this
      if (_this.answerIsEmpty) {
        //非必选，保存当前题
        //currentQuestionAnswer-当前题的 答案+选项-在组件中只有选择才会保存
        sessionStorage.setItem('currentQuestionAnswer', JSON.stringify(_this.currQuestion))
      }
      let currObj = sessionStorage.getItem('currentQuestionAnswer')
      _this.allQuestion.push(JSON.parse(currObj))
      _this.allSelectAnswer.push(_this.answerList)
      sessionStorage.setItem('allQuestion', JSON.stringify(_this.allQuestion)) //缓存答过的题
      sessionStorage.setItem('allSelectAnswer', JSON.stringify(_this.allSelectAnswer)) //缓存答过的题 答案
      sessionStorage.setItem('questionId', _this.questionId) //缓存下一题id
      // 数据缓存 e
    },
    clearSaveData() {
      sessionStorage.removeItem('currentQuestionAnswer')
      sessionStorage.removeItem('allQuestion')
      sessionStorage.removeItem('allSelectAnswer')
      sessionStorage.removeItem('questionId')
    },
    regAnswer() {
      //验证 问卷是否通过
      let _this = this
      if (_this.answerIsEmpty && _this.currQuestion.required) {
        //必选
        _this.$notify.error({
          message: _this.$t('Please choose the answer')
        })
        return false
      } else if (!_this.answerIsEmpty) {
        //是否‘其他’已经填写
        let obj = _this.answerList
        for (let keys in obj) {
          let o = obj[keys]
          if (o.input && !o.inputResult) {
            _this.$notify.error({
              message: _this.$t('Please enter the content')
            })
            return false
          }
        }
      }
      return true
    },
    setLanguage() {
      let l = this.language == 'zh' ? 'cn' : 'en'
      let info = this.info
      let config = () => {
        let msg = ''
        let lang = ''
        if (l == 'en') {
          msg = this.$t('infoCn')
          lang = 'zh'
        } else {
          msg = this.$t('infoEn')
          lang = 'en'
        }
        this.$confirm(msg, this.$t('tips'), {
          type: 'warning',
          showCancelButton: false,
          showClose: false
        })
          .then(() => {
            this.$store.commit('SET_LANGUAGE', lang)
            window.location.reload()
          })
          .catch(() => {})
      }

      if (this.subjectType == 'ACTOR') {
        // 展商
        let lang2 = info.exhibitorEmployee.exhibitor.languageType.toLowerCase()
        if (lang2 != l) {
          config()
          return false
        }
      } else {
        // 客商
        if (info && info.visitor && info.visitor.languageType.toLowerCase() != l) {
          // 完成预登记
          if (info.exhibitionUserCompleteState.completeExhibitionRegistration) {
            config()
            return false
          } else if (this.config.judgeLanguageByCountry) {
            let lang = info.visitor.languageType.toLowerCase() == 'cn' ? 'zh' : 'en'
            this.$store.commit('SET_LANGUAGE', lang)
            sessionStorage.setItem('langChange', 1)
            window.location.reload()
            return false
          }
        }
      }

      this.clearSaveData()
      this.loadQuestions()
    }
  },
  mounted() {
    window.PC.$RangersEventQuestion('questionPage_view')
    this.$nextTick(() => {
      this.setLanguage()
    })
    this.burying()
  },
  created() {
    this.clearSaveData()
  }
}
</script>
<style lang="stylus" scoped>

.v-questionnaire-wrap {
  // max-height: 670px;
  padding: 20px 0 30px;
  overflow: auto;

  .v-progress {
    width: 100%;
    max-width: 280px;
  }

  .v-question-title {
    margin-bottom: 30px;
  }

  .font-size-20 {
    font-size: 20px;
  }
}

.v-personal-question {
  max-height: fit-content;

  .v-question-title {
    margin-top: 10px;
  }
}

.bottom-todo {
  position: absolute;
  bottom: 0px;
  left: 30px;
  right: 30px;
  background: #fff;
  z-index: 100;
  padding: 0 0 30px 0;
}

.quesBtn {
  width: 400px;
  margin: auto;
}

.v-personal-question {
  .bottom-todo {
    position: static;
    background-color: transparent;
  }
}
</style>
